import { createFileRoute } from "@tanstack/react-router"
import { enforceSignupStep } from "@/features/registration-workflow"
import { SignupCityPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-city")({
	beforeLoad: () => enforceSignupStep("city"),
	component: SignupCityPage,
})
